module.exports = __webpack_public_path__ + "img/pc-button-large-02.80d8fbb8.svg";